export default [
  [
    {
      id: 'userId',
      label: 'รหัสพนักงาน',
      span: 8,
      type: 6,
      props: { padding: '8px 0', title: { text: 'รหัสพนักงาน' } },
    }, {
      id: 'firstname',
      label: 'ชื่อ-นามสกุล',
      span: 8,
      type: 6,
      props: { padding: '8px 0', title: { text: 'ชื่อ-นามสกุล' } },
    }, {
      id: 'email',
      label: 'อีเมล',
      span: 8,
      type: 6,
      props: { padding: '8px 0', title: { text: 'อีเมล' } },
    }, {
      id: 'telephone',
      label: 'เบอร์โทรศัพท์',
      span: 8,
      type: 6,
      props: { padding: '8px 0', title: { text: 'เบอร์โทรศัพท์' } },
    }, {
      id: 'roleId',
      label: 'หน้าที่',
      span: 4,
      type: 3,
      props: { dropdownStyle: { width: '100%' } },
    }, {
      id: 'status',
      label: 'สถานะ',
      span: 8,
      type: 6,
      offset: 4,
      props: { padding: '8px 0', title: { text: 'สถานะ' } },
    }, {
      id: 'warehouseId',
      label: 'คลังสินค้าที่รับผิดชอบ',
      span: 8,
      type: 7,
      offset: 4,
      props: { padding: '8px 0', title: { text: 'คลังสินค้าที่รับผิดชอบ' } },
    }, {
      id: 'driverId',
      label: 'ชื่อคนขับรถ',
      span: 4,
      type: 8,
      offset: 0,
      props: { padding: '8px 0', dropdownStyle: { width: '256px' } },
    }, {
      id: 'customerId',
      label: 'ผู้จ้าง',
      span: 8,
      type: 9,
      offset: 0,
      props: { padding: '8px 0', dropdownStyle: { width: '256px' } },
    }, {
      id: 'senderLocationId',
      label: 'ต้นทาง',
      span: 8,
      type: 10,
      offset: 0,
      props: { padding: '8px 0', dropdownStyle: { width: '256px' } },
    }, {
      id: 'receiverLocationId',
      label: 'ปลายทาง',
      span: 8,
      type: 11,
      offset: 0,
      props: { padding: '8px 0', dropdownStyle: { width: '256px' } },
    }, {
      id: 'gasstationId',
      label: 'ปั๊มน้ำมัน',
      span: 8,
      type: 12,
      offset: 0,
      props: { padding: '8px 0', dropdownStyle: { width: '256px' } },
    },
  ],
]
